import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import Vuetify from "vuetify";

Vue.config.productionTip = false;
Vue.use(Vuetify);

let vm = new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app');